<template>
  <div>
    <div class="box" :class="['box', top > 200? 'box-active':'']">
      <ul class="content-box">
        <li class="public" @mouseenter="showFn('public')" @mouseleave="hiddenFn">
          <img :src="i2" alt=""  class="img">
          <p class="title">官方微信公众号</p>
        </li>
        <li class="consulting" @mouseenter="showFn('consulting')" @mouseleave="hiddenFn">
          <img :src="i1" alt="" class="img">
          <p class="title">智绘业务咨询</p>
        </li>
        <li :class="[show == true? 'active': '', 'hover-box']" >
          <div class="hover-title">{{title}}</div>
          <div>
            <img :src="img" alt="" class="code">
            <p class="scan">扫码识别二维码</p>
          </div>
        </li>
    </ul>
    </div>
    <el-backtop>
      <div class="back-top">
        <i class="el-icon-arrow-up"></i>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import i1 from '../assets/images/1.jpg'
import i2 from '../assets/images/2.jpg'
export default {
  data () {
    return {
      i1: i1,
      i2: i2,
      img: '',
      show: false,
      title: '业务咨询',
      top: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    showFn (obj) {
      switch (obj) {
        case 'public':
          this.title = '智绘官方微信公众号'
          this.img = i2
          break
        case 'consulting':
          this.title = '智绘业务咨询'
          this.img = i1
          break
      }
      this.show = true
    },
    hiddenFn () {
      this.show = false
    },
    handleScroll (e) {
      this.top = e.target.documentElement.scrollTop || e.target.body.scrollTop || e.target.scrollTop
    }
  }
}
</script>

<style scoped>
.box{
  position: fixed;
  right: 40px;
  bottom: 100px;
  background: #ffffff;
  padding: 10px;
  border-top:5px solid rgba(252,189,1,1);
  border-bottom:4px solid rgba(252,189,1,1);
  border-left: 1px solid rgba(252,189,1,1);
  border-right: 1px solid rgba(252,189,1,1);
  border-radius: 4px;
  opacity: 0;
  transition: all 1s;
}
.box-active{
  opacity: 1;
}
.public{
  border-bottom: 1px dashed#cccccc;
  padding-bottom: 10px;
  cursor: pointer;
}
.consulting{
  padding-top: 10px;
  cursor: pointer;
}
.img{
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
}
.title{
  font-size:10px;
  font-family:PingFang SC;
  font-weight:400;
  color:rgba(112,112,112,1);
}
.content-box{
  position: relative;
}
.hover-box{
  position: absolute;
  top: -14px;
  left: -220px;
  width: 200px;
  height: 195px;
  border: 1px solid rgba(252,189,1,1);
  border-radius: 5px;
  transform: skewY(30deg) rotateY(90deg) translateZ(0);
  transition: all .5s;
  transform-origin: right;
  background: #ffffff;
}
.active{
  transform:skewY(0deg) rotateY(0deg) translateZ(0);
}
.hover-title{
  font-size: 16px;
  background:rgba(252,189,1,1);
  text-align: left;
  padding-left: 20px;
  color: #ffffff;
  line-height: 40px;
}
.scan{
  font-size:14px;
  font-family:PingFang SC;
  font-weight:400;
  color:rgba(112,112,112,1);
  margin-top: 5px;
}
.code{
  margin-top: 15px;
  width: 100px;
  height: 100px;
}
.back-top{
   height: 100%;
    width: 100%;
    background:rgba(206,206,206,1);
    box-shadow: 0 0 6px rgba(0,0,0, .12);
    text-align: center;
    line-height: 40px;
    border-radius:9px;
    color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/backTop.vue